import { useEffect, useRef, useState, useMemo } from "react";
import axios from "axios";
import RadarChartComponent from "./RadarChartComponent";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";

function Information(props) {
  const [tabCount, setTabCount] = useState(1);
  const tabMenu = ['معلومات العقار', 'معلومات المعاملة', 'التكلفة التقديرية للبناء'];
  const [windowInnerWidth, setWindowInnerWidth] = useState(window.innerWidth);
  const [informationScrollValue, setInformationScrollValue] = useState(0);
  const [contentHeightArray, setContentHeightArray] = useState([]);
  const [informationHeight, setInformationHeight] = useState(400);
  const [touchStartY, setTouchStartY] = useState(0);
  const [touchDistanceY, setTouchDistanceY] = useState(0);
  const [selectedBuildingType, setSelectedBuildingType] = useState("");
  const [aiAnalysisResult, setAiAnalysisResult] = useState(null);
  const [isAiDataLoading, setIsAiDataLoading] = useState(false);
  const noneBoxRef = useRef(null);

  const getGradeFromScore = (score) => {
    if (score >= 9) return 'A';
    if (score >= 8) return 'B';
    if (score >= 7) return 'C';
    if (score >= 5.5) return 'D';
    return 'F';
  };

  function mobileTabClick(index) {
    const before_tab_01_height = contentHeightArray[0] + 120;
    const before_tab_02_height = before_tab_01_height + contentHeightArray[1] + 60;
    const before_tab_03_height = before_tab_02_height + contentHeightArray[2] + 60;
    if (noneBoxRef.current) {
      if (index === 1) {
        noneBoxRef.current.scrollTop = before_tab_01_height;
        setTabCount(index);
      } else if (index === 2) {
        noneBoxRef.current.scrollTop = before_tab_02_height;
        setTabCount(index);
      } else {
        noneBoxRef.current.scrollTop = before_tab_03_height;
        setTabCount(index);
      }
    }
  }

  function noneBoxScrollEvent(e) {
    e.preventDefault();
    setInformationScrollValue(e.target.scrollTop);
  }

  function handleTouchStart(e) {
    setTouchStartY(e.touches[0].clientY);
  }

  function handleTouchMove(e) {
    const currentY = e.touches[0].clientY;
    const distance = currentY - touchStartY;
    setTouchDistanceY(distance);
  }

  function handleTouchEnd(e) {
    let upDown = 'same';
    if (touchDistanceY > 50) {
      upDown = 'down';
    } else if (touchDistanceY < -50) {
      upDown = 'up';
    }

    if (informationHeight === 400) {
      if (touchDistanceY > 300) {
        setInformationHeight(20);
      } else {
        if (upDown === 'down') {
          setInformationHeight(100);
        } else if (upDown === 'up') {
          setInformationHeight(400);
        }
      }
    }
    if (informationHeight === 100) {
      if (upDown === 'down') {
        setInformationHeight(20);
      } else if (upDown === 'up') {
        setInformationHeight(400);
      }
    }
    if (informationHeight === 20) {
      if (touchDistanceY < -300) {
        setInformationHeight(400);
      } else {
        if (upDown === 'down') {
          setInformationHeight(20);
        } else if (upDown === 'up') {
          setInformationHeight(100);
        }
      }
    }

    setTouchDistanceY(0);
  }

  function tab_height_check() {
    const noneBox = noneBoxRef.current;
    if (noneBox !== null) {
      const newArray = [];
      noneBox.querySelectorAll('.content_wrap').forEach((item, index) => {
        newArray.push(item.offsetHeight);
      });
      setContentHeightArray(newArray);
    }
  }

  let resetTime;
  function resizeHandle() {
    setWindowInnerWidth(window.innerWidth);
    if (window.innerWidth <= 1024) {
      setTabCount(0);
    } else {
      setTabCount(1);
    }
    clearTimeout(resetTime);
    resetTime = setTimeout(tab_height_check, 1000);
  }

  // 대만어(중국어 번체) 감지 함수
  const containsTraditionalChinese = (text) => {
    if (!text || typeof text !== 'string') return false;
    // 한자 문자 범위 체크 (CJK 통합 한자: U+4E00-U+9FFF, CJK 확장 A: U+3400-U+4DBF)
    const chineseRegex = /[\u3400-\u4DBF\u4E00-\u9FFF]/;
    return chineseRegex.test(text);
  };

  // 대만어를 아랍어로 번역하는 함수
  const translateToArabic = (text) => {
    if (!text || typeof text !== 'string') return text;
    
    // 자주 사용되는 용어 번역 맵
    const translationMap = {
      // 용도지역 관련
      '第一種住宅區': 'منطقة سكنية من النوع الأول',
      '第二種住宅區': 'منطقة سكنية من النوع الثاني',
      '第一之一種住宅區': 'منطقة سكنية من النوع الأول-1',
      '第一之二種住宅區': 'منطقة سكنية من النوع الأول-2',
      '住商混合區': 'منطقة سكنية تجارية مختلطة',
      '第一種商業區': 'منطقة تجارية من النوع الأول',
      '第二種商業區': 'منطقة تجارية من النوع الثاني',
      '第一之一種商業區': 'منطقة تجارية من النوع الأول-1',
      '複合商業區': 'منطقة تجارية مركبة',
      '第一種休閒商務區': 'منطقة أعمال ترفيهية من النوع الأول',
      '第二種休閒商務區': 'منطقة أعمال ترفيهية من النوع الثاني',
      '科技商務區': 'منطقة أعمال تقنية',
      '乙種工業區': 'منطقة صناعية من النوع ب',
      '乙種工業區(附)': 'منطقة صناعية من النوع ب (مرفق)',
      '科技產業專用區': 'منطقة مخصصة للصناعات التقنية',
      '園區事業專用區': 'منطقة مخصصة لأعمال الحديقة',
      '文教區': 'منطقة تعليمية وثقافية',
      '學校用地': 'أرض مدرسية',
      '私立學校用地': 'أرض مدرسة خاصة',
      '文高用地': 'أرض تعليم عالي',
      '文大用地': 'أرض جامعة',
      '社教用地': 'أرض تعليم مجتمعي',
      '鐵路兼社教機構用地': 'أرض سكك حديدية ومؤسسة تعليم مجتمعي',
      '鐵路兼社教用地': 'أرض سكك حديدية وتعليم مجتمعي',
      '醫療用地': 'أرض طبية',
      '醫療設施區': 'منطقة مرافق طبية',
      '社會福利設施用地': 'أرض مرافق رعاية اجتماعية',
      '宗教專用區': 'منطقة دينية مخصصة',
      '市場用地': 'أرض سوق',
      '停車場用地': 'أرض موقف سيارات',
      '加油站專用區': 'منطقة محطة وقود مخصصة',
      '加油站用地': 'أرض محطة وقود',
      '體育場用地': 'أرض ملعب رياضي',
      '公園用地': 'أرض حديقة',
      '公園兼兒童遊樂場用地': 'أرض حديقة وملعب أطفال',
      '交通用地': 'أرض نقل',
      '車站用地': 'أرض محطة',
      '轉運站用地': 'أرض محطة نقل',
      '鐵路用地': 'أرض سكك حديدية',
      '高速公路用地': 'أرض طريق سريع',
      '機關用地': 'أرض مؤسسة',
      '特定公用設施區': 'منطقة مرافق عامة محددة',
      '變電所用地': 'أرض محطة كهرباء',
      '電力事業用地': 'أرض أعمال كهربائية',
      '電信專用區': 'منطقة اتصالات مخصصة',
      '自來水事業專用區': 'منطقة مياه مخصصة',
      '瓦斯站專用區': 'منطقة محطة غاز مخصصة',
      '污水處理場用地': 'أرض محطة معالجة مياه الصرف',
      '郵政用地': 'أرض بريدية',
      '研究專用區': 'منطقة بحث مخصصة',
      
      // 행정구역 관련
      '新竹市': 'مدينة شينتشو',
      '東區': 'المنطقة الشرقية',
      '西區': 'المنطقة الغربية',
      '北區': 'المنطقة الشمالية',
      '南區': 'المنطقة الجنوبية',
      '香山區': 'منطقة شيانغشان',
      
      // 건물 유형 관련
      '單獨住宅': 'منزل منفصل',
      '公寓': 'شقة',
      '商業建築': 'مبنى تجاري',
      '工業建築': 'مبنى صناعي',
      '辦公建築': 'مبنى مكتبي',
      '文教建築': 'مبنى تعليمي',
      '醫療建築': 'مبنى طبي',
      '社會福利設施': 'مرفق رعاية اجتماعية',
      '宗教建築': 'مبنى ديني',
      '市場建築': 'مبنى السوق',
      '停車場建築': 'مبنى موقف سيارات',
      '加油站': 'محطة وقود',
      '體育設施': 'منشأة رياضية',
      '交通設施': 'منشأة نقل',
      '公用設施': 'مرفق عام',
    };
    
    // 번역 맵에 있으면 번역된 값 반환
    if (translationMap[text]) {
      return translationMap[text];
    }
    
    // 대만어가 포함되어 있지만 번역 맵에 없으면 "없음" 관련 단어 중 하나 반환
    if (containsTraditionalChinese(text)) {
      // 여러 "없음" 표현 중 랜덤하게 선택
      const noDataOptions = [
        'لا شيء',
        'غير متاح',
        'غير موجود',
        'لا يوجد',
        'فارغ',
        'غير متوفر'
      ];
      // 텍스트의 해시값을 사용하여 일관된 랜덤 선택 (같은 텍스트는 항상 같은 값)
      let hash = 0;
      for (let i = 0; i < text.length; i++) {
        hash = ((hash << 5) - hash) + text.charCodeAt(i);
        hash = hash & hash; // Convert to 32bit integer
      }
      const index = Math.abs(hash) % noDataOptions.length;
      return noDataOptions[index];
    }
    
    // 대만어가 없으면 원본 반환
    return text;
  };

  // 건물 유형 Code를 기반으로 아랍어/영어 이름 반환
  const getBuildingTypeName = (code, originalName) => {
    const buildingTypeNames = {
      'DETACHED': 'منزل منفصل',
      'APARTMENT': 'شقة',
      'COMMERCIAL': 'مبنى تجاري',
      'INDUSTRIAL': 'مبنى صناعي',
      'OFFICE': 'مبنى مكتبي',
      'EDUCATIONAL': 'مبنى تعليمي',
      'MEDICAL': 'مبنى طبي',
      'WELFARE': 'مرفق رعاية اجتماعية',
      'RELIGIOUS': 'مبنى ديني',
      'MARKET': 'مبنى السوق',
      'PARKING': 'موقف سيارات',
      'GAS_STATION': 'محطة وقود',
      'SPORTS': 'منشأة رياضية',
      'TRANSPORT': 'منشأة نقل',
      'PUBLIC_UTILITY': 'مرفق عام'
    };
    
    // Code가 있으면 번역된 이름 사용, 없으면 원본에서 대만어 제거
    if (code && buildingTypeNames[code]) {
      return buildingTypeNames[code];
    }
    
    // 원본 이름에서 대만어가 없으면 그대로 사용
    if (originalName && !containsTraditionalChinese(originalName)) {
      return originalName;
    }
    
    // 대만어만 있으면 Code 반환
    return code || 'لا شيء';
  };

  // 건물 유형 Code를 기반으로 아랍어 description 반환
  const getBuildingTypeDescription = (code, originalDescription) => {
    const buildingTypeDescriptions = {
      'DETACHED': 'بناء منزل منفصل',
      'APARTMENT': 'بناء سكن مشترك',
      'COMMERCIAL': 'مبنى تجاري',
      'INDUSTRIAL': 'منشأة صناعية ومستودع',
      'OFFICE': 'مبنى مكتبي',
      'EDUCATIONAL': 'منشأة تعليمية وثقافية',
      'MEDICAL': 'مستشفى ومنشأة طبية',
      'WELFARE': 'مرفق رعاية اجتماعية',
      'RELIGIOUS': 'مرفق ديني',
      'MARKET': 'سوق تقليدي ومتجر',
      'PARKING': 'منشأة موقف سيارات',
      'GAS_STATION': 'محطة وقود',
      'SPORTS': 'صالة رياضية ومنشأة رياضية',
      'TRANSPORT': 'محطة ومحطة نقل ومنشأة نقل',
      'PUBLIC_UTILITY': 'كهرباء ومياه وصرف صحي ومنشأة عامة'
    };
    
    // Code가 있으면 번역된 description 사용
    if (code && buildingTypeDescriptions[code]) {
      return buildingTypeDescriptions[code];
    }
    
    // 원본 description에서 대만어/한국어가 없으면 그대로 사용
    if (originalDescription && !containsTraditionalChinese(originalDescription)) {
      // 한국어도 체크 (한글 범위: U+AC00-U+D7A3)
      const koreanRegex = /[\uAC00-\uD7A3]/;
      if (!koreanRegex.test(originalDescription)) {
        return originalDescription;
      }
    }
    
    return 'لا شيء';
  };

  const formatPrice = (price) => {
    if (!price) return "غير متاح";
    // Format with thousand separators
    const formatted = new Intl.NumberFormat("en-AE", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
    return formatted + " AED";
  };

  // InfoWindow format for large amounts
  const formatPriceForInfoWindow = (price) => {
    if (!price || price === 0) return "غير متاح";
    const MILLION = 1000000;
    const millionAmount = price / MILLION;
    
    if (millionAmount >= 1) {
      // Display in millions (1 decimal place)
      return millionAmount.toFixed(1) + "M AED";
    } else {
      // Less than million, display in thousands
      const THOUSAND = 1000;
      const thousandAmount = price / THOUSAND;
      if (thousandAmount >= 1) {
        return thousandAmount.toFixed(1) + "K AED";
      } else {
        // Less than thousand, display in AED
        return formatPrice(price);
      }
    }
  };

  // zoningData가 배열인 경우 첫 번째 요소 사용
  const zoning = Array.isArray(props.zoningData) ? props.zoningData[0] : props.zoningData;
  
  // urbanPlanningData가 배열인 경우 첫 번째 요소 사용
  const urbanPlanning = Array.isArray(props.urbanPlanningData) ? props.urbanPlanningData[0] : props.urbanPlanningData;

  // 건축 가능한 유형과 예상 공사비 계산
  const applicableBuildingTypes = useMemo(() => {
    if (!props.zoningData || !props.buildingTypes || props.buildingTypes.length === 0) {
      return [];
    }

    const zoneName = zoning?.luse || zoning?.zoneType || zoning?.name;
    if (!zoneName) {
      return [];
    }

    // 해당 용도지역에 적용 가능한 건축 유형 필터링
    const applicable = props.buildingTypes.filter((type) => {
      return (
        type.applicableZoning &&
        type.applicableZoning.length > 0 &&
        type.applicableZoning.includes(zoneName)
      );
    });

    // 각 건축 유형의 예상 공사비 계산
    const landArea = props.cadastralData?.area;
    if (!landArea || landArea <= 0) {
      return applicable.map((type) => ({
        ...type,
        estimatedCost: null,
        costPerSqm: null,
      }));
    }

    return applicable.map((type) => {
      const costData = props.constructionCosts?.[type.code];
      const costPerSqm = costData?.totalCostPerSqm || 0;
      const estimatedCost = costPerSqm > 0 ? costPerSqm * landArea : null;

      return {
        ...type,
        estimatedCost,
        costPerSqm,
      };
    });
  }, [props.zoningData, props.buildingTypes, props.constructionCosts, props.cadastralData?.area, zoning]);

  // 선택된 건축 유형의 예상 공사비
  const selectedBuildingTypeCost = useMemo(() => {
    if (!selectedBuildingType || applicableBuildingTypes.length === 0) {
      return null;
    }
    const selected = applicableBuildingTypes.find((type) => type.code === selectedBuildingType);
    return selected || null;
  }, [selectedBuildingType, applicableBuildingTypes]);

  useEffect(() => {
    tab_height_check();
  }, []);

  // InfoWindow 관리 (열기, 내용 설정, 업데이트 모두 여기서 처리)
  useEffect(() => {
    if (!props.cadastralData || !props.showInformation || !window.infoWindow || !window.map) {
      return;
    }

    const cadastral = props.cadastralData;
    
    // InfoWindow 내용 생성
    let content = '<div class="infoWindow">';
    
    // 선택된 건축 유형명 표시 (번역된 이름 사용)
    if (selectedBuildingTypeCost) {
      const translatedName = getBuildingTypeName(selectedBuildingTypeCost.code, selectedBuildingTypeCost.name);
      content += `<div class="name">${translatedName}</div>`;
    } else if (selectedBuildingType && applicableBuildingTypes.length > 0) {
      const selected = applicableBuildingTypes.find((type) => type.code === selectedBuildingType);
      if (selected) {
        const translatedName = getBuildingTypeName(selected.code, selected.name);
        content += `<div class="name">${translatedName}</div>`;
      } else {
        content += '<div class="name">-</div>';
      }
    } else {
      content += '<div class="name">-</div>';
    }
    
    // Display estimated construction cost (prioritize if available)
    if (selectedBuildingTypeCost && selectedBuildingTypeCost.estimatedCost !== null && selectedBuildingTypeCost.estimatedCost > 0) {
      content += `<div class="allow">التكلفة التقديرية للبناء</div>`;
      const formattedPrice = formatPriceForInfoWindow(selectedBuildingTypeCost.estimatedCost);
      content += `<div class="estimateTotal">${formattedPrice}</div>`;
    } else {
      // If no construction cost, display area
      content += `<div class="allow">معلومات العقار</div>`;
      if (cadastral && cadastral.area) {
        content += `<div class="estimateTotal">${cadastral.area.toFixed(2)} م²</div>`;
      } else {
        content += '<div class="estimateTotal">-</div>';
      }
    }
    
    content += "</div>";
    
    // InfoWindow 위치 설정 (현재 선택된 토지의 geometry에서 계산)
    let position = null;
    
    if (window.polygonCenter) {
      // Map.js에서 저장한 폴리곤 중심 좌표 사용
      position = { lat: window.polygonCenter.lat, lng: window.polygonCenter.lng };
    } else if (cadastral?.geometry?.coordinates) {
      // geometry에서 직접 중심 좌표 계산
      try {
        const coordinates = cadastral.geometry.coordinates;
        let allCoords = [];
        
        if (cadastral.geometry.type === "Polygon" && coordinates[0]) {
          allCoords = coordinates[0];
        } else if (cadastral.geometry.type === "MultiPolygon" && coordinates[0]?.[0]) {
          allCoords = coordinates[0][0];
        }
        
        if (allCoords.length > 0) {
          // 모든 좌표의 평균으로 중심 계산
          let sumLat = 0;
          let sumLng = 0;
          allCoords.forEach((coord) => {
            sumLat += parseFloat(coord[1]); // GeoJSON은 [lng, lat] 순서
            sumLng += parseFloat(coord[0]);
          });
          position = {
            lat: sumLat / allCoords.length,
            lng: sumLng / allCoords.length
          };
        }
      } catch (error) {
        console.error("Error calculating center from geometry:", error);
      }
    }
    
    if (position) {
      try {
        // InfoWindow 열기 및 내용 설정
        window.infoWindow.setContent(content);
        window.infoWindow.setPosition(position);
        
        // InfoWindow가 아직 열려있지 않으면 열기
        if (!window.infoWindow.getMap()) {
          window.infoWindow.open(window.map);
        }
      } catch (error) {
        console.error("Error updating InfoWindow:", error);
      }
    }
  }, [props.cadastralData, props.showInformation, selectedBuildingTypeCost, selectedBuildingType, applicableBuildingTypes]);

  useEffect(() => {
    window.addEventListener('resize', resizeHandle);
    return () => {
      window.removeEventListener('resize', resizeHandle);
    };
  }, []);

  useEffect(() => {
    const before_tab_01_height = contentHeightArray[0];
    const before_tab_02_height = before_tab_01_height + contentHeightArray[1];
    const before_tab_03_height = before_tab_02_height + contentHeightArray[2] + 60;
    if (informationScrollValue < before_tab_01_height) {
      setTabCount(0);
    }
    if (informationScrollValue > before_tab_01_height && informationScrollValue < before_tab_02_height) {
      setTabCount(1);
    }
    if (informationScrollValue > before_tab_02_height && informationScrollValue < before_tab_03_height) {
      setTabCount(2);
    }
    if (informationScrollValue > before_tab_03_height) {
      setTabCount(3);
    }
  }, [informationScrollValue]);

  // 건축 가능 유형이 변경되면 첫 번째 유형을 자동 선택
  useEffect(() => {
    if (applicableBuildingTypes.length > 0 && !selectedBuildingType) {
      setSelectedBuildingType(applicableBuildingTypes[0].code);
    } else if (applicableBuildingTypes.length === 0) {
      setSelectedBuildingType("");
    }
  }, [applicableBuildingTypes, selectedBuildingType]);

  // cadastralData나 address가 변경되면 AI 분석 결과 초기화
  useEffect(() => {
    setAiAnalysisResult(null);
    setIsAiDataLoading(false);
  }, [props.cadastralData, props.address]);

  // AI 분석 탭이 선택되면 토지평가 데이터 가져오기
  useEffect(() => {
    if (tabCount === 3 && props.cadastralData && !aiAnalysisResult && !isAiDataLoading) {
      const fetchAiAnalysis = async () => {
        setIsAiDataLoading(true);
        try {
          const cadastral = props.cadastralData;
          const zoning = Array.isArray(props.zoningData) ? props.zoningData[0] : props.zoningData;
          
          // 주소 구성 (Dubai 주소 형식)
          const addressStr = props.address ? [
            props.address.administrative_area_level_1,
            props.address.administrative_area_level_2,
            props.address.route,
            props.address.street_number
          ].filter(Boolean).join(' ') : undefined;

          // 주변 정보 구성 (거래 정보, 건물 정보 등)
          const nearbyInfoParts = [];
          if (props.transactionData && (Array.isArray(props.transactionData) ? props.transactionData.length > 0 : props.transactionData)) {
            const transactionCount = Array.isArray(props.transactionData) ? props.transactionData.length : 1;
            nearbyInfoParts.push(`يوجد ${transactionCount} سجلات معاملة قريبة`);
          }
          if (props.buildingData) {
            nearbyInfoParts.push('يوجد مبنى قريب');
          }
          const nearbyInfo = nearbyInfoParts.length > 0 ? nearbyInfoParts.join('، ') : undefined;

          const response = await axios.post(`${API_BASE_URL}/land-evaluation/analyze`, {
            address: addressStr || 'معلومات العنوان غير كافية',
            landUse: cadastral?.tName || 'معلومات غير كافية',
            area: cadastral?.area || 0,
            zoning: zoning?.luse || zoning?.zoneType || zoning?.name || 'معلومات غير كافية',
            landHeight: undefined,
            nearbyInfo: nearbyInfo,
          });
          
          // 응답 데이터 설정
          setAiAnalysisResult(response.data);
          setIsAiDataLoading(false);
        } catch (error) {
          console.error('AI 분석 데이터 로딩 오류:', error);
          console.error('Error details:', error.response?.data || error.message);
          setIsAiDataLoading(false);
        }
      };
      
      fetchAiAnalysis();
    }
  }, [tabCount, props.cadastralData, props.address, props.zoningData, props.transactionData, props.buildingData, aiAnalysisResult, isAiDataLoading]);

  // 건축 가능 규모 계산 (메모이제이션) - early return 전에 호출해야 함
  const buildingScaleData = useMemo(() => {
    const landArea = props.cadastralData?.area;
    const buildRateStr = zoning?.buildRate || zoning?.BUILDRATE;
    const volumeRateStr = zoning?.volumeRate || zoning?.VOLUMERATE;
    const buildingCoverageRatio = buildRateStr ? parseFloat(buildRateStr) : null;
    const floorAreaRatio = volumeRateStr ? parseFloat(volumeRateStr) : null;
    const zoneName = zoning?.luse || zoning?.zoneType || zoning?.name;
    
    const hasLandArea = landArea && landArea > 0;
    const hasBuildRate = buildingCoverageRatio !== null && !isNaN(buildingCoverageRatio);
    const hasVolumeRate = floorAreaRatio !== null && !isNaN(floorAreaRatio);
    
    if (hasLandArea && hasBuildRate && hasVolumeRate) {
      const maxBuildingArea = landArea * (buildingCoverageRatio / 100);
      const maxTotalFloorArea = landArea * (floorAreaRatio / 100);
      const estimatedFloors = Math.round((floorAreaRatio / buildingCoverageRatio) * 10) / 10;
      
      return {
        zoneName,
        buildingCoverageRatio,
        floorAreaRatio,
        maxBuildingArea,
        maxTotalFloorArea,
        estimatedFloors
      };
    }
    
    return null;
  }, [props.cadastralData?.area, zoning?.buildRate, zoning?.volumeRate, zoning?.luse]);

  if (!props.cadastralData) {
    return (
      <div className={`informationWrap ${props.showInformation ? 'show' : ''}`}>
        <div className="loadingModule">
          <svg className="loadingImage" width="184" height={informationHeight === 20 ? "0" : "90"} viewBox="0 0 181 79" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M180,79V43L90,2.4L1.3,43V79H180Z" />
          </svg>
        </div>
      </div>
    );
  }

  const cadastral = props.cadastralData;
  const transaction = props.transactionData;
  const building = props.buildingData;
  const town = props.townData;
  const village = props.villageData;

  return (
    <div className={`informationWrap ${props.showInformation ? 'show' : ''}`}
      style={windowInnerWidth > 1024 ? {} : { height: `${informationHeight - touchDistanceY}px` }}>
      <div className="M_infoBtn_wrap"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}>
        <div className="M_infoBtn">
          <p className="infoBtn_line"></p>
        </div>
      </div>
      {props.loadingModule === true ?
        <div className={`loadingModule`}>
          <svg className="loadingImage" width="184" height={informationHeight === 20 ? "0" : "90"} viewBox="0 0 181 79" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M180,79V43L90,2.4L1.3,43V79H180Z" />
          </svg>
        </div> : ''}
      <div className={`noneBox ${informationScrollValue > 40 ? 'sticky' : ""}`} ref={noneBoxRef} onScroll={noneBoxScrollEvent}>
        <div className="topWrap">
          <div className="titleBox">{cadastral.landNo || "غير متاح"}</div>
          <div className='subTitleBox'>{translateToArabic(cadastral.tName) || "لا شيء"}</div>
          <div className="allowWrap">
            <div className="content">
              <div className="selectWrap">
                <select 
                  className="allowBuildingList"
                  value={selectedBuildingType}
                  onChange={(e) => setSelectedBuildingType(e.target.value)}
                >
                  {applicableBuildingTypes.length > 0 ? (
                    applicableBuildingTypes.map((type) => (
                      <option key={type.code} value={type.code}>
                        {getBuildingTypeName(type.code, type.name)}
                      </option>
                    ))
                  ) : (
                    <option value="">لا شيء</option>
                  )}
                </select>
                <span className="allowBuildingTitle">نوع المبنى</span>
              </div>
            </div>
            {/* <button className="more_btn">更多</button> */}
          </div>
        </div>
        <div className="bottomWrap">
          <div className="bigTabMenuWrap">
            {tabMenu.map((item, index) => {
              return (
                <div 
                  key={index} 
                  className={`bigTabMenu ${tabCount === index + 1 ? "selected" : ""}`}
                  onClick={() => { setTabCount(index + 1) }}
                >
                  {item}
                </div>
              );
            })}
          </div>
          <div className="infoBox">
            <div className="content_container">
              {tabCount === 1 || windowInnerWidth <= 1024 ?
                <div className="tab_01 content_wrap">
                  <div className="content_box">
                    <div className="title">رقم الأرض</div>
                    <div className="content">{cadastral?.landNo || cadastral?.landCode || "لا شيء"}</div>
                  </div>
                  <div className="content_box">
                    <div className="title">المساحة</div>
                    <div className="content">{cadastral?.area ? cadastral.area.toFixed(2) + " م²" : "لا شيء"}</div>
                  </div>
                  <div className="content_box">
                    <div className="title">المنطقة</div>
                    <div className="content">{translateToArabic(cadastral?.tName) || "لا شيء"}</div>
                  </div>
                  <div className="content_box">
                    <div className="title">المنطقة الإدارية</div>
                    <div className="content">{translateToArabic(town?.name || town?.townName) || "لا شيء"}</div>
                  </div>
                  <div className="content_box">
                    <div className="title">القرية</div>
                    <div className="content">{translateToArabic(village?.villName || village?.name || village?.villageName) || "لا شيء"}</div>
                  </div>
                  <div className="content_box">
                    <div className="title">التقسيم</div>
                    <div className="content">{translateToArabic(zoning?.luse || zoning?.zoneType || zoning?.name) || "لا شيء"}</div>
                  </div>
                  <div className="content_box">
                    <div className="title">التخطيط الحضري</div>
                    <div className="content">{translateToArabic(urbanPlanning?.planName || urbanPlanning?.name) || "لا شيء"}</div>
                  </div>
                  {buildingScaleData && (
                    <>
                      <div className="content_box" style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #e0e0e0' }}>
                        <div className="title" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }}>المقياس القابل للبناء</div>
                      </div>
                      <div className="content_box">
                        <div className="title">التقسيم</div>
                        <div className="content">{translateToArabic(buildingScaleData.zoneName) || "لا شيء"}</div>
                      </div>
                      <div className="content_box">
                        <div className="title">نسبة تغطية المبنى</div>
                        <div className="content">{buildingScaleData.buildingCoverageRatio}%</div>
                      </div>
                      <div className="content_box">
                        <div className="title">نسبة مساحة الطابق</div>
                        <div className="content">{buildingScaleData.floorAreaRatio}%</div>
                      </div>
                      <div className="content_box">
                        <div className="title">أقصى مساحة للمبنى</div>
                        <div className="content">{buildingScaleData.maxBuildingArea.toFixed(2)} م²</div>
                      </div>
                      <div className="content_box">
                        <div className="title">أقصى إجمالي مساحة الطابق</div>
                        <div className="content">{buildingScaleData.maxTotalFloorArea.toFixed(2)} م²</div>
                      </div>
                      <div className="content_box">
                        <div className="title">العدد التقديري للطوابق</div>
                        <div className="content">تقريباً {buildingScaleData.estimatedFloors} طابق</div>
                      </div>
                    </>
                  )}
                  {selectedBuildingTypeCost && (
                    <>
                      <div className="content_box" style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #e0e0e0' }}>
                        <div className="title" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }}>التكلفة التقديرية للبناء</div>
                      </div>
                      <div className="content_box">
                        <div className="title">نوع المبنى</div>
                        <div className="content">{getBuildingTypeName(selectedBuildingTypeCost.code, selectedBuildingTypeCost.name) || "لا شيء"}</div>
                      </div>
                      {selectedBuildingTypeCost.costPerSqm !== null && selectedBuildingTypeCost.costPerSqm > 0 ? (
                        <>
                          <div className="content_box">
                            <div className="title">السعر لكل متر مربع</div>
                            <div className="content">{formatPrice(selectedBuildingTypeCost.costPerSqm) + " / م²"}</div>
                          </div>
                          {selectedBuildingTypeCost.estimatedCost !== null && (
                            <div className="content_box">
                              <div className="title" style={{ fontSize: '15px', fontWeight: 'bold' }}>التكلفة التقديرية الإجمالية</div>
                              <div className="content" style={{ fontSize: '16px', fontWeight: 'bold', color: '#AB35D5' }}>
                                {formatPrice(selectedBuildingTypeCost.estimatedCost)}
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="content_box">
                          <div className="title">التكلفة التقديرية للبناء</div>
                          <div className="content" style={{ color: '#999' }}>البيانات غير كافية، لا يمكن الحساب</div>
                        </div>
                      )}
                    </>
                  )}
                </div>
                : ""}
              {tabCount === 2 || windowInnerWidth <= 1024 ?
                <div className="tab_02 content_wrap">
                  {transaction && (Array.isArray(transaction) ? transaction.length > 0 : true) ? (
                    (Array.isArray(transaction) ? transaction : [transaction]).map((trans, index) => (
                      <div key={trans?.id || index} style={{ 
                        marginTop: index > 0 ? '30px' : '0', 
                        paddingTop: index > 0 ? '30px' : '0', 
                        borderTop: index > 0 ? '2px solid #e0e0e0' : 'none' 
                      }}>
                        <div className="content_box" style={{ marginBottom: '15px' }}>
                          <div className="title" style={{ fontSize: '16px', fontWeight: 'bold', color: '#AB35D5' }}>
                            معلومات المعاملة {index + 1}
                            {trans?.distance && (
                              <span style={{ fontSize: '12px', fontWeight: 'normal', color: '#999', marginLeft: '10px' }}>
                                (المسافة: {trans.distance.toFixed(0)}م)
                              </span>
                            )}
                          </div>
                        </div>
                        {trans?.location && (
                          <div className="content_box">
                            <div className="title">الموقع</div>
                            <div className="content">{translateToArabic(trans.location) || "لا شيء"}</div>
                          </div>
                        )}
                        {trans?.town && (
                          <div className="content_box">
                            <div className="title">المنطقة الإدارية</div>
                            <div className="content">{translateToArabic(trans.town) || "لا شيء"}</div>
                          </div>
                        )}
                        {trans?.caseSubj && (
                          <div className="content_box">
                            <div className="title">موضوع القضية</div>
                            <div className="content">{translateToArabic(trans.caseSubj) || "لا شيء"}</div>
                          </div>
                        )}
                        {trans?.transDate && (
                          <div className="content_box">
                            <div className="title">تاريخ المعاملة</div>
                            <div className="content">
                              {(() => {
                                let dateStr = trans.transDate.toString();
                                if (dateStr.length === 6) {
                                  return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}`;
                                } else if (dateStr.length === 7) {
                                  return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-0${dateStr.substring(6, 7)}`;
                                } else if (dateStr.length === 8) {
                                  return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
                                }
                                return dateStr;
                              })()}
                            </div>
                          </div>
                        )}
                        {trans?.totPrice && (
                          <div className="content_box">
                            <div className="title">السعر الإجمالي</div>
                            <div className="content">{formatPrice(trans.totPrice)}</div>
                          </div>
                        )}
                        {trans?.unitPrice && (
                          <div className="content_box">
                            <div className="title">سعر الوحدة</div>
                            <div className="content">{formatPrice(trans.unitPrice) + " / م²"}</div>
                          </div>
                        )}
                        {trans?.lndTrnsfAr && (
                          <div className="content_box">
                            <div className="title">مساحة نقل الأرض</div>
                            <div className="content">{trans.lndTrnsfAr.toFixed(2)} م²</div>
                          </div>
                        )}
                        {trans?.cntInfo && (
                          <div className="content_box">
                            <div className="title">معلومات العقد</div>
                            <div className="content">{translateToArabic(trans.cntInfo) || "لا شيء"}</div>
                          </div>
                        )}
                        {trans?.buldType && (
                          <div className="content_box">
                            <div className="title">نوع المبنى</div>
                            <div className="content">{translateToArabic(trans.buldType) || "لا شيء"}</div>
                          </div>
                        )}
                        {trans?.buldTotFlr && (
                          <div className="content_box">
                            <div className="title">إجمالي طوابق المبنى</div>
                            <div className="content">{trans.buldTotFlr} طابق</div>
                          </div>
                        )}
                        {trans?.buldMainPu && (
                          <div className="content_box">
                            <div className="title">الاستخدام الرئيسي للمبنى</div>
                            <div className="content">{translateToArabic(trans.buldMainPu) || "لا شيء"}</div>
                          </div>
                        )}
                        {trans?.buldMainMt && (
                          <div className="content_box">
                            <div className="title">المادة الرئيسية للمبنى</div>
                            <div className="content">{translateToArabic(trans.buldMainMt) || "لا شيء"}</div>
                          </div>
                        )}
                        {trans?.buldTrnsff && (
                          <div className="content_box">
                            <div className="title">نقل المبنى</div>
                            <div className="content">{translateToArabic(trans.buldTrnsff) || "لا شيء"}</div>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="content_box">
                      <div className="content" style={{ color: '#999', textAlign: 'center', padding: '20px' }}>
                        لا توجد معلومات معاملة قريبة
                      </div>
                    </div>
                  )}
                </div>
                : ""}
              {tabCount === 3 || windowInnerWidth <= 1024 ?
                <div className="tab_03 content_wrap">
                  {isAiDataLoading ? (
                    <div className="content_box" style={{ textAlign: 'center', padding: '40px 20px' }}>
                      <div className="content" style={{ color: '#999' }}>جارٍ تحليل AI، يرجى الانتظار...</div>
                    </div>
                  ) : aiAnalysisResult ? (
                    <div className="content_wrap">
                      <div className="ai_land_info_wrap">
                        <div className="top_wrap_border">
                          <div className="top_wrap">
                            <RadarChartComponent data={[
                              aiAnalysisResult.토지가격 || aiAnalysisResult['سعر الأرض'] || 0,
                              aiAnalysisResult.투자가치 || aiAnalysisResult['قيمة الاستثمار'] || 0,
                              aiAnalysisResult['법적 규제'] || aiAnalysisResult['القيود القانونية'] || 0,
                              aiAnalysisResult.소음 || aiAnalysisResult['الضوضاء'] || 0,
                              aiAnalysisResult.인구규모 || aiAnalysisResult['حجم السكان'] || 0,
                              aiAnalysisResult.교통및접근성 || aiAnalysisResult['النقل وإمكانية الوصول'] || 0,
                              aiAnalysisResult['지형 및 토양'] || aiAnalysisResult['التضاريس والتربة'] || 0,
                              aiAnalysisResult.편의시설 || aiAnalysisResult['المرافق'] || 0,
                              aiAnalysisResult['인프라 및 공공시설'] || aiAnalysisResult['البنية التحتية والمرافق العامة'] || 0,
                            ]} />
                            <div className="row white"></div>
                            <div className="bottom_wrap">
                              <div className="left_wrap">
                                <div className="title">SCORE</div>
                                <div className="point">
                                  <img src={`/images/map/ai_land_score_${getGradeFromScore(parseFloat(aiAnalysisResult.SCORE)).toLowerCase()}.png`} alt={getGradeFromScore(parseFloat(aiAnalysisResult.SCORE))} />
                                  <div className="score_text">{aiAnalysisResult.SCORE}</div>
                                </div>
                              </div>
                              <div className="right_wrap">
                                <div className="titles">
                                  <div className="title">قيمة التقييم AI</div>
                                </div>
                                <div className="row verticle"></div>
                                <div className="prices">
                                  {aiAnalysisResult.AI評估價值 && (
                                    <div className="price">
                                      {(() => {
                                        const value = aiAnalysisResult.AI評估價值;
                                        if (typeof value === 'string' && /^\d+$/.test(value)) {
                                          return parseInt(value, 10).toLocaleString() + ' (AED/م²)';
                                        }
                                        return value + (value.includes('AED') || value.includes('م²') ? '' : ' (AED/م²)');
                                      })()}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {(aiAnalysisResult.AI分析摘要 || aiAnalysisResult.AI분석요약) && (
                          <div className="ai_summary">
                            <div className="title">
                              <img src="/images/map/ai_summary_icon.png" alt="AI Summary" />
                              ملخص تحليل AI
                            </div>
                            <div className="des">
                              {aiAnalysisResult.AI分析摘要 || aiAnalysisResult.AI분석요약}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="content_box" style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #e0e0e0' }}>
                      <div className="title" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '15px' }}>معلومات العقار</div>
                      <div className="content_box">
                        <div className="title">رقم الأرض</div>
                        <div className="content">{cadastral?.landNo || cadastral?.landCode || "لا شيء"}</div>
                      </div>
                      <div className="content_box">
                        <div className="title">المساحة</div>
                        <div className="content">{cadastral?.area ? cadastral.area.toFixed(2) + " م²" : "لا شيء"}</div>
                      </div>
                      <div className="content_box">
                        <div className="title">التقسيم</div>
                        <div className="content">{translateToArabic(zoning?.luse || zoning?.zoneType || zoning?.name) || "لا شيء"}</div>
                      </div>
                      <div className="content_box" style={{ marginTop: '20px', textAlign: 'center', padding: '20px' }}>
                        <div className="content" style={{ color: '#999' }}>
                          اضغط على الزر أعلاه لبدء تحليل AI
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                : ""}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Information;

